export default __webpack_public_path__ + "static/media/10.42ff7c9c.svg";